import { Person } from '../../beans/Person';
import { EditCaseMainComponent } from '../../cases/edit-case/edit-case-main/edit-case-main.component';
import { BlockUiService } from '../../services/blockui.service';
import { PersonService } from '../../services/person.service';
import { PersonComponent } from '../person.component';
import { Component, OnInit, ViewContainerRef, Host, ViewChild, Optional, HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
	selector: 'app-edit-person',
	templateUrl: './edit-person.component.html',
	styleUrls: ['./edit-person.component.scss']
})
export class EditPersonComponent implements OnInit {

	@ViewChild('personModal') public childModal: ModalDirective;

	@ViewChild('personForm') public personForm: NgForm;

	selectedPerson: Person;
	errorMessage = '';
	isLegalEntity: boolean;
	isEdit: boolean;
	// below is only used when called from EditCaseMainComponent
	_callbackListName: string = null;
	private parentCaseEdit;

	constructor(
		private personService: PersonService,
		private blockUi: BlockUiService, private vcRef: ViewContainerRef,
		@Optional() @Host() private parentComp: PersonComponent,
	) {

	}

	ngOnInit() {
		this.isLegalEntity = false;
		this.refreshPerson();
	}

	public editPerson(personObj: Person): void {
		this.refreshPerson();
		this.errorMessage = '';
		if (personObj) {
			this.selectedPerson.copy(personObj);
			this.isLegalEntity = this.selectedPerson.legalEntity;
		}
		this.childModal.show();
	}

	public editPersonForCase(personObj: Person, parentCaseEdit, callbackListName: string): void {
		this.editPerson(personObj);
		this.parentCaseEdit = parentCaseEdit;
		this._callbackListName = callbackListName;
		this.isEdit = true;
	}

	public createPerson(callbackListName: string, parentCaseEdit): void {
		this.refreshPerson();
		this.childModal.show();
		this.isEdit = false;
		if (callbackListName) {
			this.parentCaseEdit = parentCaseEdit;
			this._callbackListName = callbackListName;
		}
	}

	savePerson() {
		this.blockUi.start(this.vcRef);
		this.personService.savePerson(this.selectedPerson).subscribe(
			result => {
				console.log(result);
				if (this.parentComp) {
					this.parentComp.searchPerson();
				}
				if (this.parentCaseEdit) {
					if (this.isEdit) {
						this.selectedPerson = result;
						this.parentCaseEdit.reloadPersons(this.selectedPerson, this._callbackListName);
					} else {
						this.parentCaseEdit.addPersonToList(result, this._callbackListName);
					}
				}
				this.blockUi.stop();
				alert('Записахте успешно това лице!');
				this.close();
			}, error => {
				console.log(error);
				if (error.status === 406) {
					alert('Вече съществуващо лице!');
				} else {
					alert('Възникна грешка!');
				}
				this.blockUi.stop();
			});
		this.blockUi.stop();
	}

	close() {
		this.childModal.hide();
	}

	refreshPerson() {
		this.selectedPerson = new Person();
	}

	toggleVisibility(e) {
		this.isLegalEntity = e.target.checked;
		this.selectedPerson.legalEntity = this.isLegalEntity;
	}
}
